// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-l_hb","advertDetailServiceList__header":"c-l_hc","advertDetailServiceList__list":"c-l_he"};